import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Link, Box} from 'views/components';

const NavbarLogo = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <Link
        href='/'
        underline='none'
      >
        <Typography
          sx={{
            'color': 'white',
            'fontWeight': 500,
            'fontSize': '24px',
            'display': 'inline-block',
          }}
        >
          CareQuilt
        </Typography>
      </Link>
    </Box>
  );
};

NavbarLogo.propTypes = {
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarLogo));
